'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoVolumeMute = function IoVolumeMute(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm17.5 17l3.7-4v14l-3.7-4h-5.1v-6h5.1z m8.4-12.3c5.4 3 9.1 8.7 9.1 15.3 0 9.7-7.8 17.5-17.5 17.5-3 0-5.9-0.8-8.4-2.1l-0.1-0.1c-5.4-3-9-8.7-9-15.3 0-9.7 7.8-17.5 17.5-17.5 3 0 5.9 0.8 8.4 2.2h0z m2.4 23c1.5-2.2 2.6-4.8 2.6-7.7 0-5.2-3-9.6-7.2-11.8-0.5-0.2-0.9-0.5-1.4-0.6-1.4-0.6-3.1-0.9-4.8-0.9-2.9 0-5.5 1-7.7 2.5l5.7 5.8h-6l-2.8-2.7c-1.5 2.2-2.5 4.8-2.5 7.7 0 5.1 2.8 9.5 7 11.7 0.5 0.3 1.1 0.6 1.5 0.7 1.5 0.6 3.1 0.9 4.8 0.9 2.9 0 5.6-1 7.8-2.5l-1.6-1.6v-6z' })
        )
    );
};

exports.default = IoVolumeMute;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/volume-mute.js
// module id = 2554
// module chunks = 0